import moment from 'moment'

export const customerComplaintQuality = {
  id: '',
  distributedToInternal: '',
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  phone: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  createdBy: '',
  updatedBy: '',
  ccSalesAttachment: '',
  ccAreaOwnerAttachment: '',
  ownerMemberId: '',
  action: '',
  comment: '',
  feedback: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const customerComplaintDetail = {
  customerComplaintId: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
}

export const customerComplaintCorrectiveExternal = {
  id: '',
  customerComplaintId: '',
  investigationDetail: '',
  corrective: '',
  preventive: '',
}

export const customerComplaintCorrectiveInternal = {
  id: '',
  correctiveActionNumber: '',
  customerComplaintId: '',
  rootCause: '',
  corrective: '',
  correctivePicId: '',
  correctiveTargetDate: moment().format('YYYY-MM-DD'),
  preventive: '',
  preventivePicId: '',
  preventiveTargetDate: moment().format('YYYY-MM-DD'),
}

export const correctivePreventiveInternal = {
  id: '',
  customerComplaintId: '',
  rootCauseType: '',
  rootCauseRemark: '',
  rootCauseRemarkExternal: '',
  actionType: '',
  actionRemark: '',
  actionRemarkExternal: '',
  workDescription: '',
  evidence: '',
  picId: '',
  picName: '',
  picEmail: '',
  targetDate: moment().format('YYYY-MM-DD'),
}

export const customerComplaintInvestigationDetail = {
  id: '',
  customerComplaintId: '',
  question: '',
  memberId: '',
  responder: '',
  email: '',
  answer: '',
  attachment: '',
  answeredAt: '',
}

export const customerComplaintActionTracker = {
  id: '',
  correctiveActionNumber: '',
  complaintNo: '',
  rootCause: '',
  type: '',
  memberId: '',
  pic: '',
  email: '',
  workDescription: '',
  evidence: '',
  completionDate: moment().format('YYYY-MM-DD'),
}

export const customerComplaintActionTrackerLog = {
  id: '',
  customerComplaintId: '',
  memberId: '',
  type: '',
  item: '',
  remark: '',
  isAnswered: '',
}

export const customerComplaintActionTrackerLogNew = {
  id: '',
  actionNo: '',
  customerComplaintId: '',
  picId: '',
  picEmail: '',
  picName: '',
  actionType: '',
  rootCauseType: '',
  item: '',
  remark: '',
}

export const customerComplaintQuestion = {
  id: '',
  customerComplaintId: '',
  question: '',
  answer: '',
  answeredAt: moment().format('YYYY-MM-DD'),
  needAttachment: 0,
  attachment: '',
}